/*
 * Ryan O'Dowd
 * 2022-02-27
 *
 * © Copyright 2022 Oakwood Software Consulting, Inc.  All Rights Reserved.
*/
import {
  Dimensions,
  Platform,
} from 'react-native';
import DeviceInfo from 'react-native-device-info';

let WEB_CLIENT_ID = '';
let BUNDLE_ID = '';
let APPLE_REDIRECT_URI = 'https://wrinkly-dev.firebaseapp.com/__/auth/handler';
let STRIPE_KEY = 'pk_test_51LKVgwIYLz4DlAmRgCZwAj1Ju8nRCjl8eooGHhe11jjjBm1eY16fEoTjOdRiPVNZACJFNF3QEhftkF4OCCf2xyVF00LCScICdP';
const env = Platform.OS === 'web'
  ? (window.document.location.host === 'wrink.ly') ? 'prod' : (window.document.location.hostname === 'localhost' ? 'local' : 'dev') // @TODO: there's definitely a much better way to get this
  : process.env.NODE_ENV === 'production' ? 'prod' : 'dev';
if (['local', 'dev'].includes(env)) {
  WEB_CLIENT_ID = '895606346021-fgdg41rnkplnag7nrvvak2lp2sjmf5om.apps.googleusercontent.com';
  BUNDLE_ID = 'com.oakwoodsc.wrinkly.dev';
} else if (env === 'prod') {
  WEB_CLIENT_ID = '182142003913-1mnrr2akh9ph3a3o56kir78q6rtlq5sm.apps.googleusercontent.com';
  BUNDLE_ID = 'com.oakwoodsc.wrinkly';
  APPLE_REDIRECT_URI = 'https://wrinkly-prod.firebaseapp.com/__/auth/handler';
  STRIPE_KEY = 'pk_live_51LKVgwIYLz4DlAmRL1CKev5pdPXLoLdLxMWKfrShI9PWWYaKg6doJMWsyrqVgtQEaRhzUqy8WduniYxWQyWU22A2000Vop0hO4';
}

let apiUrl = 'http://localhost:5010'; // local env for web only
if (Platform.OS === 'android') { // @TODO: still need this? or will localhost work? (localhost calls are made on android, but they all return network error...flask returns a 200 though...)
  apiUrl = 'http://192.168.1.176:5010'; // cherry
}
if (env === 'prod') {
  apiUrl = 'https://api.wrink.ly';
}

const isMacLikeIOS = Platform.OS === 'ios' && DeviceInfo.getDeviceType() === 'Desktop';
const isNativeDesktop = Platform.OS === 'macos' || Platform.OS === 'windows';
const isChromebook = Platform.OS === 'web' && /CrOS/.test(navigator.userAgent);
const isWebDesktop = Platform.OS === 'web' && !/Android|iPhone|iPad|iPod|Windows Phone|Mobile/i.test(navigator.userAgent);
const isMobileSize = Dimensions.get('window').width < 640; // @TODO: if Platform.OS === 'android', there's no good way to know if it's a chromebook...maybe autocorrect needs to be a setting; also good for web styling on mobile phone
const isDesktop = (isNativeDesktop || isMacLikeIOS || isChromebook || isWebDesktop) && !isMobileSize;

const globals = {
  env,
  appVersionNumber: Platform.OS === 'web' ? __APP_VERSION__ : DeviceInfo.getVersion(),
  appName: 'wrinkly',
  apiUrl,
  webUrl: env === 'prod' ? 'https://wrink.ly' : 'http://localhost:3010',

  appStoreUrl: 'https://itunes.apple.com/us/app/id1615885499?mt=8&ls=1',
  playStoreUrl: 'https://play.google.com/store/apps/details?id=com.oakwoodsc.wrinkly',
  webClientId: WEB_CLIENT_ID, // required for GoogleOneTapSignIn on web (android and ios are auto detected via firebase)
  bundleId: BUNDLE_ID,
  appleRedirectUri: APPLE_REDIRECT_URI,

  deviceType: isDesktop ? 'desktop' : 'mobile',

  mediaQuerySizes: {
    xs: 600,
    sm: 960,
    md: 1280,
    lg: 1920,
    // xl > 1920
  },

  profilePictureSize: 1000,

  peanutsNeededToRepairStreak: 30,
  numDaysStreakIsRepairable: 10,
  srsLevelWrinkleIsEarnedAt: 3,

  stripeKey: STRIPE_KEY,

  adminAuthIds: env === 'prod' // @TODO: this should only be used in hooks/useIsAdmin...should we move this into that function?
    ? [
      'geUqjDXiOCVOtJeVBEc42BIXtno1', // rodowd prod
      'WkdHncP1Q5MQaiyy41wgG1ZFAnn2', // wrinkly_support prod
    ]
    : [
      'qDZUc6nY29RQKVysCoDCPp3BDBu2', // rodowd dev
      'P40emDW3MHNO0Fqco1in39yJXpl1', // wrinkly_support dev
    ],

  supportEmail: 'support@wrink.ly',

  wrinklyBotId: 1,

  yearPlanGoalId: 23397,

  fontScales: {
    small: 0.8,
    medium: 1.0,
    large: 1.4,
    extraLarge: 1.8,
  },

  maxInnerWidth: 1000,

  timeoutMessage: '504 timeout',
};

export const channelIds = {
  DEFAULT: 'default',
  FEEDBACK: 'feedback',
  STREAK_REMINDER: 'streak',
  WHATS_NEW: 'whats_new',
  DAILY_GOALS_REMINDER: 'daily_goals',
  PASSAGE_OF_THE_DAY: 'passage_of_the_day',
  FRIENDS: 'friends',
  DEADLINES: 'deadlines',
};

export default globals;
